import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { VideoThumbnailModule } from '@app/src/app/components/Input/VideoThumbnail';
import { LogoAnchoredModule } from '@app/src/app/components/LogoAnchored';
import { SwipeContainerModule } from '@app/src/app/components/SwipeContainer';
import { MgContentLinkModule } from '@app/src/app/content-link';
import { CommentListViewModule } from '@app/src/app/content-views/components/CommentListView';
import { MgDirectivesModule } from '@app/src/app/directives';
import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgEllipsisModule } from '@app/src/app/elements/MgEllipsis';
import { MgPersonMinimalModule } from '@app/src/app/elements/MgPersonMinimal';
import { MgProgressiveImageModule } from '@app/src/app/elements/MgProgressiveImage';
import { MgIconModule } from '@app/src/app/icon';
import { InputsModule } from '@app/src/app/inputs';
import { DesignedSvgViewerModule } from '@app/src/app/minga-designer/components/DesignedSvgViewer';
import { MgOverlayToolsModule } from '@app/src/app/overlay/tools';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgPipesModule } from '@app/src/app/pipes';
import { MgSpinnerModule } from '@app/src/app/spinner';
import { UgcLinksContentPipeModule } from '@app/src/app/ugc-links/pipes/UgcLinksContent';

import { CommentViewModule } from '../CommentView';
import { LongCardComponent } from './LongCard.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgAvatarModule,
    MgPersonMinimalModule,
    MgEllipsisModule,
    MgSpinnerModule,
    MgIconModule,
    MgProgressiveImageModule,
    MgDirectivesModule,
    MgPipesModule,
    SwipeContainerModule,
    VideoThumbnailModule,
    CommentViewModule,
    InputsModule,
    PermissionsModule,
    UgcLinksContentPipeModule,
    MgOverlayToolsModule,
    DesignedSvgViewerModule,
    LogoAnchoredModule,
    CommentListViewModule,
    MgContentLinkModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
    RouterModule,
  ],
  declarations: [LongCardComponent],
  exports: [LongCardComponent],
})
export class LongCardModule {}
